import * as React from 'react';
import {
    Create,
    SimpleForm,
    ReferenceInput,
    AutocompleteInput,
    TextInput,
    NumberInput,
    BooleanInput,
} from 'react-admin';

export const AddNewProdApprovalEntryForm = props => {
    const productionId = props.match.params.productionId;

    const transform = data => ({
        ...data,
        production_id: parseInt(productionId, 10),
    });

    const redirect = `/productions/${productionId}/show/prod-approvals`;
    const { staticContext, ...rest } = props;

    return (
        <Create basePath="" resource="production-approval-entries" {...rest} transform={transform}>
            <SimpleForm redirect={redirect}>
                <ReferenceInput source="user_id" reference="users" label="User" perPage={1000}>
                    <AutocompleteInput optionText="name" />
                </ReferenceInput>
                <TextInput source="role_name" label="Role Name" />
                <NumberInput source="stage" label="Stage" defaultValue={1} inputProps={{ min: 1 }} />
                <BooleanInput source="wildcard_approval" label="Wildcard Approval" />
                <BooleanInput source="can_undo_final_approval" label="Can Undo Final Approval" />
            </SimpleForm>
        </Create>
    );
};
